
import LookupFormInputBase from './LookupFormInputBase';
import Component from 'vue-class-component';

@Component({})
export default class MultiLookupFormInput extends LookupFormInputBase {}
